<template>
  <aha-modal @hide="hide()" :title="getModalTitle">
    <div v-if="isCreateFromPresenter">
      <div class="tab-content">
        <p>
          By removing this member:
        </p>
        <ul class="ul">
          <li>
            They will lose access to the team presentations.
          </li>
          <li>
            Presentations & folders created by this member will be transferred to the team owner.
          </li>
        </ul>
      </div>
    </div>
    <div v-else>
      <div class="tab-content">
        <p>
          Removing <b>{{ member.firstName + ' ' + member.lastName + ' ('+ member.email + ')' }}</b>
          from your team will:
        </p>
        <ul class="ul">
          <li>
            Free up 1 licence.
          </li>
          <li>
            Revert their plan to Free.
          </li>
          <li>
            They will lose access to the team presentations.
          </li>
          <li>
            Presentations & folders created by this member will be transferred to the team owner.
          </li>
        </ul>
      </div>
    </div>
    <template #action>
      <aha-button
        variant="danger"
        :disabled="isRemovingMember"
        @click="handleRemoveAccountFromTeam()"
        icon-name="delete"
        :submitting="isRemovingMember"
        has-margin-right
      >
        <aha-spinner variant="white" class="mr-1" v-if="isRemovingMember" />
        Remove
      </aha-button>
      <aha-link @click="hide()">
        <span class="font-bold">Cancel</span>
      </aha-link>
    </template>
  </aha-modal>
</template>
<script>

// constants
import gaCategories from '@/constant/gaCategories'

import Util from '@/util'
import AccountApi from '@/api/account'

export default {
  props: {
    member: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isRemovingMember: false,
      modalContent: '',
    }
  },
  computed: {
    isCreateFromPresenter() {
      return this.$store.state.currentAccount.createdFrom === 'presenter'
    },
    getModalTitle() {
      return `Are you sure you want to remove ${this.member.firstName} from your team?`
    },
  },
  created() {

  },
  mounted() {
  },

  methods: {
    async handleRemoveAccountFromTeam() {
      this.isRemovingMember = true
      try {
        await AccountApi.deleteAccount(this.member.id)
        Util.gaTrackEvent(
          gaCategories.MY_TEAM,
          'Team management > Remove member from team > Removed successfully',
        )
        this.$emit('getTeamMember')
        this.$emit('hide')
        Util.showToastSuccess(`Removed email: "${this.member.email}"`)
      } catch (error) {
        Util.gaTrackEvent(
          gaCategories.MY_TEAM,
          'Team management > Remove member from team > Remove failed',
        )
        Util.showToastError(`Remove email: "${this.member.email}" failed`)
        throw new Error('My Team > Get account by ID failed.')
      } finally {
        this.isRemovingMember = false
      }
    },
    hide() {
      this.$emit('hide')
    },
  },
}
</script>
<style scoped lang="scss">
.tab-content {
  .ul {
    list-style: disc !important;
    padding-left: 1.25rem !important;
  }
}
</style>
